import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate/dist/vee-validate.js'
import en from 'vee-validate/dist/locale/en'
import es from 'vee-validate/dist/locale/es'
import alphaFull from '@/validator/rules/alphaFull'
import alphaNumSpaces from '@/validator/rules/alphaNumSpaces'
import alphaSerie from '@/validator/rules/alphaSerie'
import document from '@/validator/rules/document'
import maxFileSize from '@/validator/rules/maxFileSize'
import totalFileSize from '@/validator/rules/totalFileSize'
import table from '@/validator/rules/table'
import iban from '@/validator/rules/iban'
import bknAlgorithm from '@/validator/rules/bknAlgorithm'
import confirmPassword from '@/validator/rules/confirmPassword'
import dateAfter from '@/validator/rules/dateAfter'
import dateBefore from '@/validator/rules/dateBefore'
import customNum from '@/validator/rules/customNum'
import totalAmmount from '@/validator/rules/totalAmount'
import fileType from '@/validator/rules/fileType'
import maxAmount from '@/validator/rules/maxAmount'
import alphaSpecial from '@/validator/rules/alphaSpecial'
import notSupportedNumber from '@/validator/rules/notSupportedNumber'
import validDate from '@/validator/rules/validDate'
import dateFromSubscription from '@/validator/rules/dateFromSubscription'
import dateOldInvoices from '@/validator/rules/dateOldInvoices'
import noDisposableEmail from '@/validator/rules/noDisposableEmail'
import cifNotProvider from '@/validator/rules/cifNotProvider'
import customEmailValidator from '@/validator/rules/customEmailValidator'
import detailsTable from '@/validator/rules/detailsTable'
import esPhone from '@/validator/rules/esPhone'
import faceb2b from '@/validator/rules/faceb2b'
import validTReference from '@/validator/rules/validTReference'
import validFileName from '@/validator/rules/validFileName'

export const bus = new Vue()
Validator.extend('alpha_full', alphaFull)
Validator.extend('alpha_serie', alphaSerie)
Validator.extend('document', document)
Validator.extend('iban', iban)
Validator.extend('bkn_number', bknAlgorithm)
Validator.extend('maxFileSize', maxFileSize)
Validator.extend('totalFileSize', totalFileSize)
Validator.extend('table', table)
Validator.extend('totalAmmount', totalAmmount)
Validator.extend('fileType', fileType)
Validator.extend('same_pass', confirmPassword)
Validator.extend('date_after', dateAfter, { hasTarget: true })
Validator.extend('date_before', dateBefore, { hasTarget: true })
Validator.extend('custom_num', customNum)
Validator.extend('maxAmount', maxAmount)
Validator.extend('alphanum_spaces', alphaNumSpaces)
Validator.extend('alphaSpecial', alphaSpecial)
Validator.extend('notSupportedNumber', notSupportedNumber)
Validator.extend('validDate', validDate)
Validator.extend('dateFromSubscription', dateFromSubscription)
Validator.extend('dateOldInvoices', dateOldInvoices)
Validator.extend('noDisposableEmail', noDisposableEmail)
Validator.extend('cifNotProvider', cifNotProvider)
Validator.extend('customEmailValidator', customEmailValidator)
Validator.extend('detailsTable', detailsTable)
Validator.extend('esPhone', esPhone)
Validator.extend('faceb2b', faceb2b)
Validator.extend('validTReference', validTReference)
Validator.extend('validFileName', validFileName)

export const veeCfg = (i18n = null) => {
  return {
    errorBagName: 'veeErrors', // change if property conflicts
    fieldsBagName: 'veeFields',
    delay: 0,
    dictionary: { es, en },
    strict: true,
    classes: false,
    classNames: {
      touched: 'touched', // the control has been blurred
      untouched: 'untouched', // the control hasn't been blurred
      valid: 'valid', // model is valid
      invalid: 'invalid', // model is invalid
      pristine: 'pristine', // control has not been interacted with
      dirty: 'dirty' // control has been interacted with
    },
    events: 'input|blur',
    inject: true,
    validity: false,
    aria: true,
    i18n, // the vue-i18n plugin instance,
    i18nRootKey: 'validations' // the nested key under which the validation messsages will be located
  }
}

export default VeeValidate
